// @noflow
import AsyncRoute from './async-route';
import { connect } from 'react-redux';
import { getIsLoggedIn, getIsLoggingOut } from '~/core/state/application/selectors';
import { getTranslationsLoading } from '~/core/state/translations/selectors';
import * as React from 'react';
import { withRouter } from 'react-router';
import { withTracker } from '~/components/universal-analytics';

/*
    isLoadingTranslations is a HACK!
    When isLoadingTranslations changes, we know that we're replacing the translations used in react-intl.
    react-intl attaches translations to the React context and because react-redux connect uses
    shouldComponentUpdate, components making use of translations aren't automatically re-rendered.
    The problem is that context is broken in React. isLoadingTranslations gives react-redux a reason to re-render
    and in turn, the new context is picked up and used.
*/

const mapStateToProps = state => ({
    isLoggedIn: getIsLoggedIn(state),
    isLoggingOut: getIsLoggingOut(state),
    isLoadingTranslations: getTranslationsLoading(state)
});

export const Routes = ({ isLoggedIn, isLoggingOut }) => {
    return (
        <div>
            <AsyncRoute entry="post-auth" isLoggedIn={isLoggedIn} sLoggingOut={isLoggingOut} />
            <AsyncRoute entry="pre-auth" isLoggedIn={isLoggedIn} isLoggingOut={isLoggingOut} />
        </div>
    );
};

export default withRouter(withTracker(connect(mapStateToProps)(Routes)));



// WEBPACK FOOTER //
// ./src/routes/index.js